import React from "react";
import { useParams } from "react-router-dom";

function BrandPage() {
  const { brandId } = useParams();

  return (
    <div className="brand-page">
      <h2>Brand: {brandId}</h2>
      <p>This is where we will display all models for this brand.</p>
    </div>
  );
}

export default BrandPage;
